import React from "react";
import './style.css';
import { Strings, Images } from "../../Constants";

const DebitCard = () => {
    return (
        <div className='container deb-container'>
            <div className='d-flex flex-wrap-reverse   align-items-center debit-card-container'>
                <div className='col-12 col-md-12 col-xl-6 col-lg-10 card-title-holder '>
                    <div className='col-9 col-md-10 col-lg-10 col-xl-11 card-title'>
                        <h3 className='card-title'>{Strings.REWARD_CARD_TITLE}<span style={{ color:"#D1964A"}}> free Satoshis{/* Bitcoin */}</span></h3>
                    </div>
                    <div className='col-10 col-xl-10 card-sub-title'>
                        <p>{Strings.REWAD_CARD_SUBTITLE}</p>
                    </div>
                    <div className="col-12 col-md-8 col-lg-5 col-xl-8 carddownloadLinks " >
                        <div className="col-md-4 col-lg-5 button-appStore appstore" >
                            <a href="https://apps.apple.com/in/app/gosats-bitcoin-rewards-app/id1536263998"
                                target="_blank" rel="noreferrer">
                                <img src={Images.appstore}
                                    className="appStoreLogo"
                                    alt="App Store"
                                    style={{ width: 126, hight: 40 }}
                                />
                            </a>
                        </div>
                        <div className=" col-md-4 col-lg-4 button-appStore playstore" >
                            <a href="https://play.google.com/store/apps/details?id=io.gosats"
                                target="_blank" rel="noreferrer">
                                <img src={Images.playstore}
                                    className="cardGooglePlayLogo"
                                    alt="Google play"
                                    style={{ width: 126, hight: 40 }}
                                />
                            </a>
                        </div>
                    </div>
                    {/* <div className='mt-5 mb-4 d-flex  flex-wrap  debit-card-pnone-num-container'>
                        <div className='col-6 col-md-3 col-lg-4 col-xl-4 debit-card-input-phone-number'>
                            <span className='mr-1' style={{ color: "#FFFFFF" }}>+91</span>
                            <input type='tel'  maxLength="10" size="10" className='debit-card-phone-num-input' />
                        </div>
                        <div className='col-5 ms-3 col-md-4 col-lg-6 col-xl-4'>
                            <button className='debit-card-send-button'>
                                Send link !
                            </button>
                        </div>
                    </div> */}
                </div>
                <div className='col-12 d-flex  col-xl-5 col-lg-5 justify-content-left col-md-6 card-holder'>
                     <img src={Images.debitCard} alt='Debit card' className='debit-card-img' />
                     <img src={Images.mobileView} alt='Debit card' className='debit-card-img-Mob' />
                </div>
            </div>
        </div>
    );
}

export default DebitCard;
/* 
<div className='col-12 d-flex col-md-12 col-xl-6 col-lg-6 justify-content-end col-md-6 card-holder'>
<img src={Images.debitCard} alt='Debit card' className='debit-card-img' />
</div> */